<!--
  - 代码编辑器
-->

<template>
	<div class="build_editor">
		<div class="menu" :style="{height: layout.menu.height}">
			<widget_menu ref="ref_menu" @main_run_key="main_run_key" @submit_command="submit_command"></widget_menu>
		</div>
		
		<div class="viewport">
			<widget_filelist :more_show="code_list.more_show" @more="get_list_more" @click="get_code"
			                 :data="code_list.page.data" v-show="layout.filelist.show" :width="layout.filelist.width"
			                 :height="layout.filelist.height"></widget_filelist>
			<div class="editor">
				<ace ref="ref_editor" :content="editor_status.content" :top="layout.editor.top" :bottom="layout.editor.bottom"
				     :height="layout.editor.height" :width="layout.editor.width" :lang="get_raw_mode(editor_status.language)"
				     :theme="editor_status.theme" :size="editor_status.size" :keymap="editor_status.keymap"
				     :options="{showLineNumbers:this.editor_status.line_number_visible,showInvisibles: this.editor_status.charset_visible}"></ace>
				<widget_terminal ref="ref_terminal" :bottom="layout.terminal.bottom" :height="layout.terminal.height"
				                 :width="layout.terminal.width" @terminalClose="terminalClose"
				                 :show="layout.terminal.show"></widget_terminal>
			</div>
		</div>
		
		<widget_statusbar :height="layout.status.height"></widget_statusbar>
		
		<!--保存代码modal-->
		<Modal v-model="save_modal.show" :footer-hide="true" :title="save_modal.title" :loading="save_modal.loading">
			<Form :model="save_form" ref="save_form" :rules="saveValidate" :label-width="60">
				<FormItem label="标题" prop="title">
					<Input v-model="save_form.title" placeholder="请输入代码标题"/>
				</FormItem>
				<FormItem label="描述" prop="description">
					<Input v-model="save_form.description" placeholder="请输入代码描述"/>
				</FormItem>
				<FormItem label="公开访问" :label-width="85">
					<Checkbox v-model="save_form.is_public === 1"></Checkbox>
				</FormItem>
				<FormItem>
					<Row>
						<Col span="4" offset="13">
							<Button type="primary" long @click="SaveCode">提交</Button>
						</Col>
						<Col span="4" offset="1">
							<Button type="default" long @click="CloseSaveModal">取消</Button>
						</Col>
					</Row>
				</FormItem>
			</Form>
		</Modal>
		
		<!--提示是否匿名modal-->
		<Modal v-model="share_tip_modal.show" class="share_tip_modal" title="保存并生成分享链接">
			<p>您当前的代码尚未保存，保存再生成分享链接将会展示您的署名以及统计访问与执行次数。是否将本段代码保存后生成分享链接？</p>
			<div slot="footer" style="text-align: right">
				<i-button type="primary" @click="OpenSaveModal">是，前往保存</i-button>
				<i-button @click="ShareAnonymousLink">否，匿名分享</i-button>
			</div>
		</Modal>
		
		<!--获取分享链接modal-->
		<Modal v-model="share_modal.show" class="share_modal" :footer-hide="true" title="获取代码分享链接">
			<Row>
				<Col span="18">
					<Input :readonly="true" v-model="share_modal.link"></Input>
				</Col>
				<Col span="3" offset="1">
					<Button type="primary" v-clipboard:copy="share_modal.link" v-clipboard:success="onClipboardSuccess"
					        v-clipboard:error="onClipboardError">点击复制
					</Button>
				</Col>
			</Row>
		</Modal>
	</div>
</template>


<script>
	import ace from '@/lib/vue2-ace-ext'
	import widget_menu from './menu'
	import widget_filelist from './filelist'
	import widget_terminal from './terminal'
	import widget_statusbar from './statusbar'
	import {mapGetters} from 'vuex'
	import config from "../../../config"
	import {CreateWebsocket} from "../../../apilist/websocket"

	export default {
		name: 'build_editor',
		data(){
			return {
				ternimal_socket: null,
				main_content_height: 0,
				main_content_width: 0,
				layout: {
					menu: {
						height: '35px',
					},
					filelist: {
						width: '250px',
						height: '200px',
						show: false,
					},
					editor: {
						height: '180px',
						width: '100px',
						top: '70px',
						bottom: '0px',
					},
					terminal: {
						show: true,
						bottom: '30px',
						height: '350px',
						width: '100px',
					},
					status: {
						height: '30px',
					}
				},
				mode_alias: {
					'PHP7': 'php',
					'Node': 'javascript',
					'Python': 'python',
					'Shell': 'shell',
					'Lua': 'lua',
					'Perl': 'perl',
					'C': 'c_cpp',
					'Cpp': 'c_cpp',
					'Golang': 'golang',
					'Java': 'java',
					'Ruby': 'ruby',
				},
				language_alias: {
					'PHP7': 'php7',
					'Node': 'node',
					'Python': 'python',
					'Shell': 'shell',
					'Lua': 'lua',
					'Perl': 'perl',
					'Cpp': 'cpp',
					'C': 'c',
					'Golang': 'golang',
					'Java': 'java',
					'Ruby': 'ruby',
				},
				code_list: {
					page: {},
					more_show: false,
				},
				share_modal: {
					show: false,
					link: '正在生成,请稍等...',
				},
				share_tip_modal: {
					show: false,
				},
				save_modal: {
					title: '',
					show: false,
					loading: false,
				},
				save_form: {
					id: null,
					title: '',
					description: '',
					is_public: true,
					mode: 'save',
				},
				saveValidate: {
					title: [
						{required: true, message: '请输入代码标题'}
					],
				},
				hash_code: {},
			};
		},
		components: {
			widget_menu,
			ace,
			widget_filelist,
			widget_terminal,
			widget_statusbar,
		},
		mounted(){
			// 绑定编辑器事件
			let that = this;
			this.$nextTick(()=>{
				that.resizeEditor();
				that.$refs.ref_terminal.resizeTerminal();

				$(window).resize(function(){
					that.resizeEditor();
					that.$refs.ref_terminal.resizeTerminal();
				});
			});

			this.$on('editor-update', function(data){
				this.editor_status.content = data;
				this.CommitStatusAndRefreshBar();
			});

			this.$on('editor-focus', function(data){
				this.calc_status();
			});

			this.$on('editor-cursor', function(data){
				this.calc_status();
			});

			this.$on('terminal-update', function(data){
				if(that.ternimal_socket !== null && that.ternimal_socket.readyState === 1){
					let send_data = {
						type: "data",
						message: data,
					};
					send_data = JSON.stringify(send_data);
					that.ternimal_socket.send(send_data);
				}
			});

			this.editor_status.language = this.$route.params.lang;

			this.CommitStatusAndRefreshBar();
			this.calc_status();
		},
		computed: {
			...mapGetters([
				'user',
				'editor_status',
			]),
		},
		methods: {
			main_run_key(key){
				if(key.type === 'lang'){
					this.active({lang: key.value});
					this.editor_status.language = key.value;
				}else if(key.type === 'theme'){
					this.editor_status.theme = key.title;
				}else if(key.type === 'size'){
					this.editor_status.size = key.title;
				}else if(key.type === 'other_line_number'){
					this.editor_status.line_number_visible = !this.editor_status.line_number_visible;
				}else if(key.type === 'other_charset_visible'){
					this.editor_status.charset_visible = !this.editor_status.charset_visible;
				}else if(key.type === 'other_grammar'){
					this.editor_status.grammar = !this.editor_status.grammar;
				}else if(key.type === 'other_keymap_normal'){
					this.editor_status.keymap = 'normal';
				}else if(key.type === 'other_keymap_vim'){
					this.editor_status.keymap = 'vim';
				}else if(key.type === 'other_keymap_emacs'){
					this.editor_status.keymap = 'emacs';
				}

				this.CommitStatusAndRefreshBar();
			},
			CommitStatusAndRefreshBar(){
				this.$store.commit('ChangeEditorStatus', this.editor_status);
				this.$refs.ref_menu.RefreshStatus();
			},
			submit_command(key){
				// open websocket
				let that = this;
				if(key === 'run'){
					// validate
					if(this.editor_status.language === "" || this.editor_status.content === ""){
						this.$refs.ref_terminal.sayWarn("interrupt: Running code cannot be empty.");
						return;
					}
					this.layout.terminal.show = true;
					//start websocket
					var startWS = function(){
						let ws = CreateWebsocket("/service/run");
						ws.binaryType = "arraybuffer";
						ws.onmessage = function(evt){
							let data = new TextDecoder().decode(evt.data);
							let recv_data = JSON.parse(data);
							let message_type = recv_data.type;
							if(message_type === "data"){
								that.$refs.ref_terminal.write(recv_data.message);
							}else if(message_type === "error"){
								that.$refs.ref_terminal.sayError(recv_data.message);
							}else if(message_type === "busy"){
								that.$refs.ref_terminal.sayHigh(recv_data.message);
							}else if(message_type === "fatal"){
								that.$refs.ref_terminal.sayHigh(recv_data.message);
							}else{
								that.$refs.ref_terminal.sayError("error: Unable to parse the data");
							}
						};

						ws.onclose = function(evt){
							that.socket_ended_at = Date.now();
							let cost_time = that.socket_ended_at - that.socket_started_at;
							that.$refs.ref_terminal.sayExit("terminal exited (" + cost_time + " ms)");
							ws.close();

							//触发菜单动画
							that.$refs.ref_menu.ChangeMenuIcon(3, "fa-play")
						};

						ws.onerror = function(err){
							if(ws.readyState === 3){
								that.$refs.ref_terminal.sayError("error: cannot connect run code server.");
							}
						};

						ws.onopen = function(){
							that.ternimal_socket = ws;
							let data = {
								language: that.editor_status.language,
								code: that.editor_status.content,
							};
							ws.send(JSON.stringify(data));
							that.socket_started_at = Date.now();

							// 触发菜单动画
							that.$refs.ref_menu.ChangeMenuIcon(3, "fa-circle-o-notch fa-spin")
						};

						return ws;
					};

					//reopen
					if(this.ternimal_socket === null){
						startWS()
					}else if(this.ternimal_socket.readyState === 3){
						startWS()
					}else{
						this.$refs.ref_terminal.sayError("error: reopen failed. please refresh and retry");
					}
				}else if(key === 'open'){
					if(this.layout.filelist.show === false){
						this.get_code_list();
					}
					this.layout.filelist.show = !this.layout.filelist.show;
				}else if(key === 'save'){
					this.OpenSaveModal();
				}else if(key === 'save_as'){
					this.OpenSaveAsModal();
				}else if(key === 'share'){
					this.ShowShareLink();
				}
			},
			OpenSaveModal(){
				this.CloseAllModal();
				this.save_modal.title = '保存';
				this.save_form.title = this.editor_status.title;
				this.save_form.description = this.editor_status.description;
				this.save_form.mode = 'save';
				this.save_form.is_public = this.editor_status.is_public;
				this.save_modal.show = true;
			},
			OpenSaveAsModal(){
				this.CloseAllModal();
				this.save_modal.title = '另存为';
				this.save_form.title = '';
				this.save_form.description = '';
				this.save_form.mode = 'save_as';
				this.save_modal.show = true;
			},
			CloseSaveModal(){
				this.save_modal.show = false;
			},
			get_code_list(page = 1){
				let that = this;
				this.$fetch.user.get_user_code_list({
					page,
				}).then(data=>{
					this.code_list.page = data;
					if(data.last_page > data.current_page){
						that.code_list.more_show = true;
					}
				});
			},
			ShowShareLink(){
				if(this.editor_status.content.length === 0){
					this.$Notice.warning({
						title: '先写下您的分享代码吧',
					});
					return;
				}

				// if the user is logged in
				if(this.user === null){
					this.ShareAnonymousLink();
				}else{
					// if the current code has changed
					if(this.hash_code.content === this.editor_status.content && this.hash_code.language === this.editor_status.language){
						this.ShareAuthLink();
					}else{
						this.share_tip_modal.show = !this.share_tip_modal.show;
					}
				}
			},
			ShareAuthLink(){
				this.share_modal.link = '正在生成,请稍等...';
				this.CloseAllModal();
				this.share_modal.show = !this.share_modal.show;
				this.$fetch.user.get_code_share_link_auth(this.editor_status).then(data=>{
					this.share_modal.link = config.host + data.url;
				});
			},
			ShareAnonymousLink(){
				this.share_modal.link = '正在生成,请稍等...';
				this.CloseAllModal();
				this.share_modal.show = !this.share_modal.show;
				this.$fetch.user.get_code_share_link_anonymous(this.editor_status).then(data=>{
					this.share_modal.link = config.host + data.url;
				});
			},
			calc_status(){
				let position = this.$refs.ref_editor.GetCursorPosition();
				this.editor_status.row = position.row;
				this.editor_status.col = position.column;
				this.editor_status.count = this.editor_status.content.length;
				this.CommitStatusAndRefreshBar();
			},
			get_code(data){
				this.$router.push({
					name: 'BuildView',
					params: {
						lang: data.language,
						hash: data.hash,
					}
				});

				// 获取当前代码详情
				let hash = this.$route.params.hash || data.hash;
				if(hash){
					this.get_user_code(hash);
				}
			},
			get_list_more(){
				let that = this;
				this.$fetch.user.get_user_code_list({
					page: this.code_list.page.current_page + 1,
				}).then(data=>{
					// 获取新数据
					that.code_list.more_show = data.last_page > data.current_page;
					this.code_list.page.current_page = data.current_page;
					this.code_list.page.last_page = data.last_page;
					this.code_list.page.total = data.total;

					_.each(data.data, (item, index)=>{
						this.code_list.page.data.push(item);
					});
				});
			},
			SaveCode(){
				this.$refs['save_form'].validate((valid)=>{
					if(valid){
						this.$fetch.user.save_user_code({
							code_id: this.editor_status.id,
							title: this.save_form.title,
							description: this.save_form.description,
							language: this.editor_status.language,
							content: this.editor_status.content,
							is_public: this.save_form.is_public,
							mode: this.save_form.mode,
						}).then(data=>{
							this.save_modal.show = false;
							this.get_code_list();
							this.get_code(data);
							this.$Notice.success({
								title: '保存成功',
								desc: '您的代码已成功保存',
							})
						});
					}
				});
			},
			CloseAllModal(){
				this.CloseSaveModal();
				this.share_modal.show = false;
				this.share_tip_modal.show = false;
			},
			get_raw_mode(language){
				return this.mode_alias[language];
			},
			terminalClose(){
				this.layout.terminal.show = false;
			},
			resizeEditor(){
				let that = this;
				this.main_content_height = window.innerHeight;
				this.main_content_width = window.innerWidth;

				//
				let header_height = 35;
				let editor_height = 0;
				let editor_width = 0;
				let editor_bottom = 0;
				let filelist_height = 0;

				//set editor height
				if(this.layout.terminal.show === true){
					editor_height = this.main_content_height - header_height - parseInt(this.layout.menu.height) - parseInt(this.layout.status.height) - parseInt(this.layout.terminal.height);
				}else{
					editor_height = this.main_content_height - header_height - parseInt(this.layout.menu.height) - parseInt(this.layout.status.height);
				}
				this.layout.editor.height = editor_height + 'px';

				if(this.layout.terminal.show === true){
					editor_bottom = (parseInt(this.layout.terminal.height) + parseInt(this.layout.status.height)) + 'px';
				}else{
					editor_bottom = parseInt(this.layout.status.height) + 'px';
				}
				this.layout.editor.bottom = editor_bottom;


				//set editor width
				if(this.layout.filelist.show === true){
					editor_width = this.main_content_width - parseInt(this.layout.filelist.width);
				}else{
					editor_width = this.main_content_width;
				}
				this.layout.editor.width = editor_width + 'px';
				this.layout.terminal.width = editor_width + 'px';


				//set filelist height
				filelist_height = this.main_content_height - header_height - parseInt(this.layout.menu.height) - parseInt(this.layout.status.height);
				this.layout.filelist.height = filelist_height + 'px';
			},
			active(params){
				this.$router.replace({
					name: 'Build',
					params,
				})
			},
			get_user_code(hash){
				this.$fetch.user.get_user_code({
					hash,
				}).then(data=>{
					this.editor_status.title = data.title;
					this.editor_status.language = data.language;
					this.editor_status.code_id = data.code_id;
					this.editor_status.hahs = data.hash;
					this.editor_status.content = data.content;
					this.editor_status.author = data.author;
					this.editor_status.description = data.description;
					this.editor_status.is_public = data.is_public;

					// 修改编辑器内容
					this.$refs.ref_editor.SetEditorContent(this.editor_status.content);
					this.CommitStatusAndRefreshBar();

					// 快照当前获取代码
					this.hash_code = data;
				});
			},
			onClipboardSuccess(){
				this.$Notice.success({
					title: '已成功复制至剪贴板',
				})
			},
			onClipboardError(){
				this.$Notice.error({
					title: '复制剪贴板失败',
				})
			}
		},
		created(){
			let hash = this.$route.params.hash;
			if(hash !== undefined){
				this.get_user_code(hash);
			}
		},
		watch: {
			'editor_status.content': function(newValue, oldValue){
				this.calc_status();
			},
			'layout.terminal.show': function(newValue, oldValue){
				this.resizeEditor();
				this.$refs.ref_terminal.resizeTerminal();
			},
			'layout.filelist.show': function(newValue, oldValue){
				this.resizeEditor();
				this.$refs.ref_terminal.resizeTerminal();
			},
			'layout.editor.width': function(newValue, oldValue){
			},
			'layout.editor.height': function(newValue, oldValue){
			},
		}
	}
</script>

<style scoped lang="less">
	.build_editor {
		display: flex;
		flex-direction: column;
		
		.menu {
		}
		
		.share_modal {
		}
		
		.editor {
			flex: 1 1 auto;
		}
		
		.viewport {
			display: flex;
			flex-direction: row;
		}
	}
</style>

